<template>
  <v-card tile light>
    <v-toolbar
      dark
      flat
      color="secondary"
      max-height="56"
    >
      <v-btn
        icon
        color="primary"
        @click.stop="cancel()"
      >
        <v-icon v-text="icons.close" />
      </v-btn>
      <v-spacer />
      <v-toolbar-title v-text="$store.state.orders.menu.item.name" />
      <v-spacer />
      <v-btn
        icon
        color="primary"
        @click.stop="done()"
      >
        <v-icon v-text="icons.done" />
      </v-btn>
    </v-toolbar>
    <h-menu-header class="px-2" />
    <v-card-text class="px-2">
      <h-menu-items />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <h-menu-dots />
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'
  import HMenuHeader from './Header'
  import HMenuItems from './Items'
  import HMenuDots from './Dots'

  export default {
    mixins: [
      UsesIcons,
    ],

    components: {
      HMenuHeader,
      HMenuItems,
      HMenuDots,
    },

    methods: {
      cancel () {
        this.$emit('close')
      },
      done () {
        this.$store
          .dispatch('orders/menu/validate')
          .then(success => {
            if (success) {
              this.$emit('complete')
              this.$emit('close')
            }
          })
      },
    },
  }
</script>
